<template>
    <v-dialog
        :value="isOpen"
        max-width="650px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Odzyskiwanie hasła
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid>
                    <v-row justify="center">
                        <v-col cols="12">
                            <p class="mb-0">
                                Podaj nazwę użytkownika, aby odzyskać dostęp.
                                Po zatwierdzeniu formularza na Twój adres e-mail zostanie wysłana wiadomość z linkiem do zmiany hasła.
                            </p>
                        </v-col>
                        <v-col cols="12" sm="6" class="pb-0">
                            <v-text-field
                                v-model="username"
                                label="Login"
                                outlined
                                dense
                                :error-messages="usernameErrors"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Zatwierdź"
                    @click="sendLink()"
                >
                    Zatwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import { required } from 'vuelidate/lib/validators'
import { appConfig } from '@/config'

export default {
    name: 'SendLinkDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            username: null,
            actionLoading: false,
        }
    },
    validations: {
        username: {
            required
        }
    },
    computed: {
        usernameErrors() {
            const errors = []

            if (!this.$v.username.$dirty) return errors
            !this.$v.username.required && errors.push('Proszę podać login.')

            return errors
        }
    },
    methods: {
        sendLink() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true

            const payload = {
                username: this.username,
                resetURL: `${appConfig.common.appUri}/password-reset`
            }

            this.$store.dispatch('sendLink', payload)
                .then(() => {
                    this.onClose()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onClose() {
            setTimeout(() => {
                this.username = null
            }, 500)
            this.$emit('on-close')
            this.$v.$reset()
        },
    }
}
</script>

